// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimEscalationNoteRequestDto
 */
export interface IClaimEscalationNoteRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimEscalationNoteRequestDto
     */
    note?: string;
}

/**
 * Check if a given object implements the IClaimEscalationNoteRequestDto interface.
 */
export function instanceOfIClaimEscalationNoteRequestDto(value: object): value is IClaimEscalationNoteRequestDto {
    return true;
}

export function IClaimEscalationNoteRequestDtoFromJSON(json: any): IClaimEscalationNoteRequestDto {
    return IClaimEscalationNoteRequestDtoFromJSONTyped(json, false);
}

export function IClaimEscalationNoteRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimEscalationNoteRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function IClaimEscalationNoteRequestDtoToJSON(json: any): IClaimEscalationNoteRequestDto {
    return IClaimEscalationNoteRequestDtoToJSONTyped(json, false);
}

export function IClaimEscalationNoteRequestDtoToJSONTyped(value?: IClaimEscalationNoteRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

